<template>
  <panel>
    <div>
      <h3>{{ message.name }}</h3>

      <hr />

      <div v-html="message.body" />
    </div>

    <div slot="footer">
      <w-button class="btn-secondary" text="Wstecz" @click="goBack" />

      <w-button class="btn-primary float-right" :text="goToEntityButtonText" @click="goToEntity" />
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { TableNameTranslations } from '@/enums/tableName';
import { getSystemMessageEntityRoute } from '@/utils/getSystemMessageEntityRoute';
import { getMessageData } from '@/utils/message';
import { tryParseInt } from '@/utils/number';

// @vuese
// Powiadomienie
// @group message
export default {
  components: { Panel },
  computed: {
    ...mapState({
      message: state => state.systemMessage.data
    }),
    goToEntityButtonText() {
      return `Przejdź do ${TableNameTranslations[this.message.entityType]}`;
    }
  },
  mounted() {
    this.$store.dispatch('systemMessage/read', tryParseInt(this.$route.params.messageId));
  },
  methods: {
    // @vuese
    // Powrót do listy powiadomień
    goBack() {
      this.$router.push({ name: 'systemMessageList' });
    },
    // @vuese
    // Przechodzi do encji powiązanej z powiadomieniem
    goToEntity() {
      getSystemMessageEntityRoute(this.message.entityType, this.message.entityId)
        .then(route => this.$router.push(route))
        .catch(() => Errors.CANNOT_GO_TO_MESSAGE_ENTITY);
    }
  },
  beforeRouteUpdate(to, from, next) {
    getMessageData(to, from, next);
  }
};
</script>
